<template>
  <div>
    <div style="margin-bottom: 5px;"><h3>广告信息管理</h3></div>
    <div style="margin: 10px 0">
      <el-button type="primary" @click="adds">新增 <i class="el-icon-circle-plus-outline"></i></el-button>
    </div>
    <el-dialog title="广告信息"  :visible.sync="addialogVisible2" width="30%">
      <el-form :model="form" size="small" label-width="30px">
        <el-form-item label="广告内容" :label-width="adformLabelWidth">
          <el-input v-model="form.ad" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
    <el-table :data="adtableData" stripe style="width: 100%" :header-cell-class-name="headerBgs">

      <el-table-column prop="ad" label="广告内容" width="1200">
      </el-table-column>
      <el-table-column prop="date" label="修改时间" width="200">
      </el-table-column>


      <el-table-column prop="operator" label="操作">
        <template slot-scope="scope">

          <el-button type="success" class="el-icon-edit" @click="handleUpdate(scope.row)">编辑</el-button>


          <el-dialog title="提示" :visible.sync="addialogVisible" width="30%">
            <span>确认删除该广告吗?</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="addialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="delad"> 确 定</el-button>
            </span>
          </el-dialog>
          <el-button type="danger" class="el-icon-remove-outline" style="margin-left: 5px"
                     @click="shanchu(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>


    <div style="padding:10px 0">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagenum"
                     :page-sizes="[5, 10, 15, 20]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper"
                     :total="total">
      </el-pagination>
    </div>


  </div>
</template>

<script>


export default {
  name: "Ad",
  data() {
    return {
      adtableData: [],
      form: {},
      total: 0,
      ad:"",
      pagesize: 5,
      pagenum: 1,
      addialogVisible: false,
      addialogVisible2: false,
      addialogFormVisible: false,
      headerBgs: 'headerBgs',
      adformLabelWidth: 20,
      id:0
    }
  },
  created() {
    this.load()
  },
  methods: {
    shanchu(row) {
      this.id = row.adID
      this.addialogVisible=true
    },
    load() {
      this.request.get("/ad", {
        params: {
          pagenum: this.pagenum,
          pagesize: this.pagesize,
        }
      })
          .then(res => {
            console.log(res.data);
            this.adtableData = res.data.data;
            this.total = res.data.total;
          })
          .catch(error => {
            console.error("Error loading data:", error);
          });
    },
    handleSizeChange(pagesize) {
      this.pagesize = pagesize
      this.load()
    },
    handleCurrentChange(pagenum) {
      this.pagenum = pagenum
      this.load()
    },
    save() {

      this.request.post("/ad", this.form).then(res => {
        if (res.code === 1) {
          console.log("123")
          this.$message.success("保存成功")
          this.addialogVisible2 = false
          this.load()
        }
        else {
          this.$message.error("保存失败")
        }
      })
    },
    handleUpdate(row) {
      this.form = row
      this.addialogVisible2 = true
      this.load()
    },
    adds() {
      this.addialogVisible2 = true
      console.log(this.addialogVisible2);
      this.form = {}
    },
    delad() {
      this.request.delete("/ad/" + this.id).then(res => {

        if (res.code === 1) {

          this.$message.success("删除成功")
          this.load()
          this.addialogVisible = false
        } else {
          this.$message.success("删除失败")
        }
      })
    }
  }
}
</script>


<style>
</style>
